export const isValidFutureDate = (dateStr) => {
    if (!dateStr || dateStr.length !== 6) return false

    const year = parseInt(dateStr.substring(0, 4))
    const month = parseInt(dateStr.substring(4, 6))

    const currentDate = new Date()
    const currentYear = currentDate.getFullYear()
    const currentMonth = currentDate.getMonth() + 1

    return year > currentYear || (year === currentYear && month > currentMonth)
}